import { useState } from "react";
import { Slider } from "@/components/ui/slider";
import { Reveal, Eyebrow } from "./Reveal";

export const Rebates = ({ onSchedule }) => {
  const [months, setMonths] = useState([12]);
  const tests = Math.round((months[0] * 30) / 14);
  const PER_TEST = 10;
  return (
    <section id="rebates" className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-36">
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal><Eyebrow>Rebate program</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1]">
              Every test<br /><span className="text-duo">pays you back.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-slate-300 text-base sm:text-lg leading-relaxed max-w-lg">
              Get <span className="text-white font-semibold">$10 refunded every time you get tested</span> — on top of $10 off when you book. Stay on your 14-day rhythm and the rebates keep stacking.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <button data-testid="rebate-claim-cta" onClick={onSchedule}
              className="mt-8 rounded-full bg-[#FF2A8D] hover:bg-[#FF54A5] px-7 py-4 font-semibold transition-colors">
              Start earning rebates
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="relative rounded-[32px] p-[1px] bg-gradient-to-br from-[#FF2A8D] via-white/10 to-[#125AA0]">
            <div className="rounded-[31px] bg-[#0B1020] p-6 sm:p-10">
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Rebate estimator</p>
              <p className="mt-6 text-sm text-slate-300">If I test every 14 days for <span className="text-white font-semibold">{months[0]} months</span></p>
              <Slider data-testid="rebate-calculator-slider" value={months} onValueChange={setMonths} min={1} max={24} step={1} className="mt-5" />
              <div className="mt-10 grid grid-cols-1 min-[420px]:grid-cols-2 gap-4">
                <div className="rounded-2xl bg-white/5 p-5">
                  <p className="font-display text-3xl sm:text-5xl font-extrabold leading-none">{tests}</p>
                  <p className="text-xs text-slate-400 mt-2">tests at $10 back each</p>
                </div>
                <div className="rounded-2xl bg-white/5 p-5">
                  <p data-testid="rebate-annual-earnings" className="font-display text-3xl sm:text-5xl font-extrabold text-duo leading-none">${tests * PER_TEST}</p>
                  <p className="text-xs text-slate-400 mt-2">refunded to you</p>
                </div>
              </div>
              <p className="mt-6 text-xs text-slate-400">$10 rebate per completed test. Plus $10 off every booking with your coupon.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
